import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

export const PageTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
